


















































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import WebhooksInjectorMixin from "@/mixins/webhooksInjectorMixin";

// Types
import { IWebhook } from "@/models/webhooks";
import { AdminRoutes } from "@/data/enums/router";

@Component({
  components: {
    "webhook-status-icon": () =>
      import("@/components/app/admin/settings/webhooks/webhookStatusIcon.vue")
  }
})
export default class WebhookRowItem extends Mixins(WebhooksInjectorMixin) {
  // Props

  @Prop({ default: null })
  public webhook!: IWebhook;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Data

  public isProcessing = false;

  // Computed

  public get showSkeleton() {
    return this.isLoading || _.isNull(this.webhook);
  }

  public get webhookRoute() {
    if (!_.isNull(this.webhook))
      return {
        name: AdminRoutes.WEBHOOKS_SETTINGS_WEBHOOK_EDIT,
        params: {
          webhookId: this.webhook.id
        }
      };

    return {};
  }

  public get triggersCount() {
    let count = 0;
    this.webhook?.subscriptions?.forEach(({ hook_category, hook_id }) => {
      if (hook_id) return count++;
      count += hook_category?.hooks_count || 0;
    });
    return count;
  }

  public get isTogglable() {
    return !this.isProcessing && this.$webhooksData.canUpdate;
  }

  // Methods

  public async toggleEnabled(value) {
    try {
      this.isProcessing = true;
      await this.$webhooksMethods.changeEnabled(this.webhook.id, value);

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.webhooks.webhook_successfully_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }
}
